export enum PolicyType {
  PRICE = 1,
  DISCOUNT = 2,
}

export const PolicyTypeNames = {
  [PolicyType.PRICE]: 'Precio',
  [PolicyType.DISCOUNT]: 'Descuento',
}
